import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { Shopping } from '../models/shopping';
import type { RootState } from '../store';

const initialState: Shopping = {
  shopCart: [],
  totalPrice: 0,
};

const setup = createSlice({
  name: 'shopping',
  initialState,
  reducers: {
    setShopCart(state, { payload }: PayloadAction<Shopping>) {
      return {
        ...state,
        shopCart: payload['shopCart'],
        totalPrice: payload['totalPrice'],
      };
    },

    clearShopCart() {
      return initialState;
    },
  },
});

export const { setShopCart, clearShopCart } = setup.actions;

export const selectShopCart = ({ shopping }: RootState) => shopping;

export default setup.reducer;
